import React, { ReactNode } from 'react';
import { BubbleForm, BubbleOverlay } from '../BubbleUI';
import buildCreateGroupResourceWorkflow from './Workflows/CreateGroupResourceWorkflow';
import { BubbleFormPage } from '../BubbleUI/BubbleForm';
import { GroupResourceForm } from './Workflows';

export interface DefaultMode {
  type: 'default';
}

export interface GroupResourceEditMode {
  type: 'edit';
  data: { id: string; name: string; price: number; resourceType: string; description: string };
}

export interface GroupResourceCreateMode {
  type: 'create';
}

export interface GroupResourceCloneMode {
  type: 'clone';
  data: { id: string; name: string; price: number; resourceType: string; description: string };
}

export type GroupsResourceMode =
  | DefaultMode
  | GroupResourceEditMode
  | GroupResourceCreateMode
  | GroupResourceCloneMode;

interface GroupResourceFormProps {
  mode: Exclude<GroupsResourceMode, DefaultMode>;
  types: string[];
  onClose: () => void;
  onSubmitGroupResource: () => void;
  data?: { id: string; name: string; price: number; type: string };
}

export default function GroupResourceForm(props: GroupResourceFormProps) {
  const pages: Array<BubbleFormPage<GroupResourceForm>> = [];
  const { onSubmitGroupResource, onClose } = props;
  let prependNode: ReactNode | undefined;
  let startAtPage: number | undefined;

  switch (props.mode.type) {
    case 'edit':
    case 'clone':
      pages.push({
        key: 'edit-clone-group-resource',
        render: () =>
          buildCreateGroupResourceWorkflow({
            mode: props.mode,
            onClose,
            resourceTypes: props.types,
            onCreated: onSubmitGroupResource,
            preloadData:
              props.mode.type === 'edit' || props.mode.type === 'clone'
                ? props.mode.data
                : undefined,
          }).prependNode,
      });
      startAtPage = 0;
      break;
    case 'create':
      pages.push({
        key: 'create-group-resource',
        render: () =>
          buildCreateGroupResourceWorkflow({
            mode: props.mode,
            onClose,
            resourceTypes: props.types,
            onCreated: onSubmitGroupResource,
          }).prependNode,
      });
      startAtPage = 0;
      break;
  }
  return (
    <div className="group-booking-form">
      {prependNode}
      <BubbleOverlay loading={false} hideBg loadingMinHeight="large">
        <BubbleForm pages={pages} startAtPage={startAtPage} />
      </BubbleOverlay>
    </div>
  );
}
